import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Sessione revocata (es. password agente cambiata): torna al login
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const isLogin = error.config?.url?.includes("/auth/login");
    if (error.response?.status === 401 && !isLogin && localStorage.getItem("tm_token")) {
      localStorage.removeItem("tm_token");
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export default api;
